import React from 'react';
import AddMedication from '../components/AddMedication';

const MedicationFormPage: React.FC = () => <AddMedication />;

export default MedicationFormPage;
